if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.hsPrimaryMap = JSON.parse(this.dataset.hsPrimaryMap || '{}');
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
      // On page load, hide all variant thumbnails immediately
if (this.elements.thumbnails) {
  this.elements.thumbnails.querySelectorAll('[data-target]').forEach((element) => {
    if (element.classList.contains('thumbnail-list_item--variant')) {
      element.style.display = 'none';
    }
  });
}
      this.syncHsVariant(this.dataset.hsSelectedVariant);
    }

    syncHsVariant(variantId) {
      if (!variantId) return;
      this.dataset.hsSelectedVariant = String(variantId);
      this.querySelectorAll('[data-hs-variant-id]').forEach(element => {
        const selected = element.dataset.hsVariantId === String(variantId);
        element.hidden = !selected;
        if (!selected) element.classList.remove('is-active');
      });
      if (this.elements.thumbnails) {
        const primary = this.hsPrimaryMap[String(variantId)];
        this.elements.thumbnails.querySelectorAll('.thumbnail-list_item--variant').forEach(element => {
          element.style.display = element.dataset.target === primary ? '' : 'none';
        });
        this.elements.thumbnails.resetPages();
      }
      if (this.elements.viewer.resetPages) this.elements.viewer.resetPages();
    }

    onSlideChanged(event) {
      if (this.dataset.desktopLayout !== 'stacked') {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
        this.setActiveThumbnail(thumbnail);
      }
    }

    setActiveMedia(mediaId, prepend) {
      const selected = Object.keys(this.hsPrimaryMap).find(id => this.hsPrimaryMap[id] === mediaId);
      if (selected) this.syncHsVariant(selected);
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
        if (element.classList.contains('product__media-item--variant')) {
          element.style.display = 'none';
        }
      });

      if (!activeMedia) return;
      activeMedia.classList.add('is-active');
      activeMedia.style.display = '';

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();

      window.setTimeout(() => {
        if (activeMedia.classList.contains('product__media-item--variant')) {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: 0 });
          }
        } else {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });

      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;

      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      if (activeThumbnail) {
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      } else {
        this.elements.viewer.slider.scrollTo({ left: activeMedia.offsetLeft });
      }
    }

    setActiveThumbnail(thumbnail) {
  if (!this.elements.thumbnails || !thumbnail) return;


  // Always deactivate all buttons first
  this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
  thumbnail.querySelector('button').setAttribute('aria-current', true);

  // If the active thumbnail is a variant, show it but don't scroll the strip to it
  if (thumbnail.classList.contains('thumbnail-list_item--variant')) {
    thumbnail.style.display = '';
    return;
  }

  thumbnail.style.display = '';
  if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
  this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
}

    announceLiveRegion(activeItem, position) {
      if (activeItem.classList.contains('product__media-item--variant')) return;
      this.elements.viewer.slider.scrollTo({ left: activeItem.offsetLeft });
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
